/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { ComuneEsercenteSummaryDTO } from './comune-esercente-summary-dto';


export interface PagedModelComuneEsercenteSummaryDTO { 
    content?: Array<ComuneEsercenteSummaryDTO>;
    page?: PageMetadata;
}

